// extracted by mini-css-extract-plugin
module.exports = {"chip":"PremiumChip_chip__U2QZv"};